/**
 * Бараа буцаалт — backend-ийн `chef-api/admin.module.js` (postProductReturn)-тэй хуваалцдаг утгууд.
 */

/** Буцаалтын тайлбарын (`warehouse_minus.note`) өмнө backend залгадаг тэмдэг. */
export const RETURN_NOTE_PREFIX = '[RETURN]';

/** `[RETURN] ...` тэмдгийг хасч, админы бичсэн тайлбарыг буцаана. */
export function stripReturnNotePrefix(note?: string | null): string {
  if (!note) return '';
  const text = String(note);
  return text.slice(0, RETURN_NOTE_PREFIX.length).toUpperCase() === RETURN_NOTE_PREFIX
    ? text.slice(RETURN_NOTE_PREFIX.length).replace(/^\s+/, '')
    : text;
}
